import { __assign, __awaiter, __generator } from "tslib";
import { MiddlewareError } from './errors';
import Logger from './logger';
var logger = Logger({ name: 'middleware-executor' });
export var middlewareClientExecutor = function (middlewares, props, middlewaresArgs) {
    if (props === void 0) { props = {}; }
    return __awaiter(void 0, void 0, void 0, function () {
        var prevData, _loop_1, _i, middlewares_1, middleware, state_1;
        var _a;
        return __generator(this, function (_b) {
            switch (_b.label) {
                case 0:
                    prevData = {};
                    _loop_1 = function (middleware) {
                        var finalArgs, finish, done, middlewareResp, error_1, middlewareError;
                        return __generator(this, function (_c) {
                            switch (_c.label) {
                                case 0:
                                    finalArgs = middlewaresArgs[middleware.id]
                                        ? middlewaresArgs[middleware.id](__assign({ ctx: {} }, props))
                                        : { allowFailure: false };
                                    finish = false;
                                    done = function () {
                                        finish = true;
                                    };
                                    _c.label = 1;
                                case 1:
                                    _c.trys.push([1, 3, , 4]);
                                    props.data = __assign(__assign({}, prevData), props.data);
                                    return [4 /*yield*/, middleware.functionMiddleware({}, props, finalArgs, done)];
                                case 2:
                                    middlewareResp = (_c.sent());
                                    if ((_a = props.redirect) === null || _a === void 0 ? void 0 : _a.destination) {
                                        window.location.replace(props.redirect.destination);
                                        return [2 /*return*/, "break"];
                                    }
                                    prevData = __assign(__assign({}, props.data), ((middlewareResp === null || middlewareResp === void 0 ? void 0 : middlewareResp.data) || {}));
                                    if (finish) {
                                        return [2 /*return*/, "break"];
                                    }
                                    return [3 /*break*/, 4];
                                case 3:
                                    error_1 = _c.sent();
                                    logger.debug("[middlewareClientExecutor] - error while executing ".concat(middleware.id, " - error: ").concat(error_1));
                                    done();
                                    if (!finalArgs.allowFailure) {
                                        middlewareError = new MiddlewareError(middleware.id, "Error executing middleware '".concat(middleware.id, "': ").concat(error_1 instanceof Error ? error_1.message : String(error_1)), error_1 instanceof Error ? error_1 : undefined);
                                        throw middlewareError;
                                    }
                                    else {
                                        prevData = __assign({}, props.data);
                                    }
                                    return [3 /*break*/, 4];
                                case 4: return [2 /*return*/];
                            }
                        });
                    };
                    _i = 0, middlewares_1 = middlewares;
                    _b.label = 1;
                case 1:
                    if (!(_i < middlewares_1.length)) return [3 /*break*/, 4];
                    middleware = middlewares_1[_i];
                    return [5 /*yield**/, _loop_1(middleware)];
                case 2:
                    state_1 = _b.sent();
                    if (state_1 === "break")
                        return [3 /*break*/, 4];
                    _b.label = 3;
                case 3:
                    _i++;
                    return [3 /*break*/, 1];
                case 4:
                    props.data = prevData;
                    return [2 /*return*/, prevData];
            }
        });
    });
};
export var middlewareServerExecutor = function (middlewares, ctx, props, middlewaresArgs) {
    if (props === void 0) { props = {}; }
    return __awaiter(void 0, void 0, void 0, function () {
        var prevData, _loop_2, _i, middlewares_2, middleware, state_2;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    prevData = {};
                    _loop_2 = function (middleware) {
                        var finalArgs, finish, done, middlewareResp, error_2, middlewareError;
                        return __generator(this, function (_b) {
                            switch (_b.label) {
                                case 0:
                                    finalArgs = middlewaresArgs[middleware.id]
                                        ? middlewaresArgs[middleware.id](__assign({ ctx: {} }, props))
                                        : { allowFailure: false };
                                    finish = false;
                                    done = function () {
                                        finish = true;
                                    };
                                    _b.label = 1;
                                case 1:
                                    _b.trys.push([1, 3, , 4]);
                                    props.data = __assign(__assign({}, prevData), props.data);
                                    return [4 /*yield*/, middleware.functionMiddleware(ctx, props, finalArgs, done)];
                                case 2:
                                    middlewareResp = (_b.sent());
                                    prevData = __assign(__assign({}, props === null || props === void 0 ? void 0 : props.data), ((middlewareResp === null || middlewareResp === void 0 ? void 0 : middlewareResp.data) || {}));
                                    if (finish) {
                                        return [2 /*return*/, "break"];
                                    }
                                    return [3 /*break*/, 4];
                                case 3:
                                    error_2 = _b.sent();
                                    logger.debug("[middlewareServerExecutor] - error while executing ".concat(middleware.id, " - error: ").concat(error_2));
                                    done();
                                    if (!finalArgs.allowFailure) {
                                        middlewareError = new MiddlewareError(middleware.id, "Error executing middleware '".concat(middleware.id, "': ").concat(error_2 instanceof Error ? error_2.message : String(error_2)), error_2 instanceof Error ? error_2 : undefined);
                                        throw middlewareError;
                                    }
                                    else {
                                        prevData = __assign({}, props.data);
                                    }
                                    return [3 /*break*/, 4];
                                case 4: return [2 /*return*/];
                            }
                        });
                    };
                    _i = 0, middlewares_2 = middlewares;
                    _a.label = 1;
                case 1:
                    if (!(_i < middlewares_2.length)) return [3 /*break*/, 4];
                    middleware = middlewares_2[_i];
                    return [5 /*yield**/, _loop_2(middleware)];
                case 2:
                    state_2 = _a.sent();
                    if (state_2 === "break")
                        return [3 /*break*/, 4];
                    _a.label = 3;
                case 3:
                    _i++;
                    return [3 /*break*/, 1];
                case 4:
                    props.data = prevData;
                    return [2 /*return*/, prevData];
            }
        });
    });
};
//# sourceMappingURL=middleware-executor.js.map